import { Box, Button, Card, CardContent, Container, Divider, Grid, Typography } from '@mui/material'
import { BackButton } from '../components/BackButton'
import { useContext, useState } from 'react'
import { HotelContext } from '../contexts/HotelContext'
import { useQuery } from '@tanstack/react-query'
import { getHotelReservation } from '../apis/hotelApis'
import { useLocation, useNavigate, useParams } from 'react-router'
import { OverlayLoader } from '../components/Loader'
import qs from 'qs'
import { DateTimeFormats } from '../common/constants'
import { DateTime } from 'luxon'
import { formatCurrency } from '../utils/numberUtil'
import { RoomSearchResult } from '../modules/RoomSearchResult'
import { getCheckInReservation, reservationLogin } from '../apis/checkinApis'
import { getNextPage } from '../utils/checkinUtils'

export const ReservationPage = () => {
  const { hotel, setReservationToken } = useContext(HotelContext)
  const { reservationId: reservationIdParams } = useParams()
  const { state, search } = useLocation()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const navigate = useNavigate()
  const reservationId = Number(reservationIdParams)
  const searchParams = qs.parse(search, {
    ignoreQueryPrefix: true,
  })
  const { data, isLoading } = useQuery({
    queryKey: ['getHotelReservation', hotel.hotelId, reservationId],
    queryFn: () => getHotelReservation(hotel.hotelId, reservationId),
  })

  const handleCheckIn = async () => {
    const payload = { ...state, ...searchParams }
    try {
      setIsSubmitting(true)
      const { token } = await reservationLogin(hotel.hotelId, {
        phoneNumber: payload.phoneNumber,
        reservationNumber: data.ReservationNumber,
      })
      await setReservationToken(token)
      const reservation = await getCheckInReservation(hotel.hotelId, reservationId)
      const { url } = getNextPage(reservation)
      navigate(url)
    } catch (err) {
    } finally {
      setIsSubmitting(false)
    }
  }

  if (isLoading) {
    return <OverlayLoader />
  }

  const room = data?.RoomTypeId && hotel.rooms?.find((item) => item.roomTypeId === data.RoomTypeId)

  return (
    <Container maxWidth="md">
      <BackButton to={`/hotel/${hotel.hotelId}`} />
      {isSubmitting && <OverlayLoader />}
      <Box padding={1}>
        <Typography
          color={(theme) => theme.palette.primary.main}
          mt={1}
          mb={2}
          textAlign="center"
          variant="h4"
          gutterBottom
          fontWeight="600">
          Đặt phòng thành công
          <Typography color={(theme) => theme.palette.grey[600]} textAlign="center" gutterBottom>
            Cám ơn bạn đã đặt phòng ở Đào Tiên
          </Typography>
        </Typography>
      </Box>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} lg={6}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography fontWeight={500} textAlign="center" gutterBottom>
                  Chi tiết đặt phòng
                </Typography>
                <Box>
                  <Typography fontSize={'1rem'} gutterBottom>
                    <span>Mã đặt phòng: </span>
                    <b>{data.ReservationNumber}</b>
                  </Typography>
                </Box>
                <Box>
                  <Typography fontSize={'1rem'} gutterBottom>
                    <span>Nhận phòng: </span>
                    <b>{DateTime.fromISO(data.ArrivalDate).toFormat(DateTimeFormats.FULL)}</b>
                  </Typography>
                </Box>
                <Box>
                  <Typography fontSize={'1rem'} gutterBottom>
                    <span>Trả phòng: </span>
                    <b>{DateTime.fromISO(data.DepartureDate).toFormat(DateTimeFormats.FULL)}</b>
                  </Typography>
                </Box>
                <Box>
                  <Typography fontSize={'1rem'} gutterBottom>
                    <span>Loại phòng: </span>
                    <b>{room.roomTypeName}</b>
                  </Typography>
                </Box>
                <Box>
                  <Typography fontSize={'1rem'} gutterBottom>
                    <span>Giá: </span>
                    <b>{formatCurrency(data.TotalPrice)}</b>
                  </Typography>
                </Box>
                <Divider />
                <Box mt={1}>
                  <Typography fontSize={'1rem'} gutterBottom>
                    <span>Số điện thoại: </span>
                    <b>{data.Mobile}</b>
                  </Typography>
                </Box>
                <Box>
                  <Typography fontSize={'1rem'} gutterBottom>
                    <span>Tên liên hệ: </span>
                    <b>{data.Fullname}</b>
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} lg={6}>
            <RoomSearchResult readonly item={room} isLoading={isLoading} />
          </Grid>
        </Grid>
      </Box>
      <Box mt={3}>
        <Button size="large" fullWidth variant="contained" onClick={handleCheckIn}>
          Nhấn để tự check-in ngay
        </Button>
      </Box>
    </Container>
  )
}
